package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import com.essntl.features.service.domain.model.service.ServiceFilterOptions
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.features.service.ui.components.ServiceFilterSection
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersEvent
import com.essntl.features.supplier.ui.allsuppliers.AllSuppliersState
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme

@Composable
fun AllServiceFilterSection(
    state: AllServiceState,
    allSuppliersState: AllSuppliersState,
    onEventAllSupplier: (AllSuppliersEvent) -> Unit,
    onCategorySelected: (String?) -> Unit,
    onFilterOptionsChange: (ServiceFilterOptions) -> Unit,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = 2.spacing,
                horizontal = 3.spacing,
            ),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceBetween,
            modifier = modifier
                .fillMaxWidth(),
        ) {
            ServiceCategoryRow(
                state = state,
                onCategorySelected = {
                    onCategorySelected(it)

                    onFilterOptionsChange(
                        state.filterOptions.copy(
                            selectedCategoryIds = setOfNotNull(it),
                        ),
                    )

                    onEventAllSupplier(
                        AllSuppliersEvent.EditFilterOptions(
                            allSuppliersState.filterOptions.copy(
                                selectedCategoryIds = setOfNotNull(it),
                            ),
                        ),
                    )
                },
                modifier = Modifier.weight(1f),
            )
        }

        Spacer(modifier = Modifier.height(2.5f.spacing))

        ServiceFilterSection(
            categoryList = state.getAllCategory.data.orEmpty(),
            tagList = state.getAllTag.data.orEmpty(),
            areaList = state.getAllArea.data.orEmpty(),
            isTagLoading = state.getAllTag.isLoading,
            isAreaLoading = state.getAllArea.isLoading,
            isCategoryFilterEnabled = false,
            isSupplierFilterEnabled = true,
            allSuppliersState = allSuppliersState,
            onEventAllSupplier = onEventAllSupplier,
            filterOptions = state.filterOptions,
            onFilterOptionsChange = onFilterOptionsChange,
            modifier = Modifier.fillMaxWidth(),
        )
    }
}